import { useRef, useState } from "react";
import Button from '@mui/joy/Button';



function UploadButton({ uploadUrl, label = "Загрузить CSV", onSuccess, onError }) {
  const fileInputRef = useRef(null);
  const [isUploading, setIsUploading] = useState(false);

  const handleClick = () => {
    if (!isUploading) fileInputRef.current?.click();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!file.name.endsWith(".csv")) {
      alert("Пожалуйста, выберите CSV-файл.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file); // имя поля можно поменять при необходимости

    try {
      setIsUploading(true);

      const response = await fetch(`${process.env.REACT_APP_TMBACK_URL}/api/${uploadUrl}`, {
        method: "POST",
        body: formData,
        credentials: "include"
      });

      const result = await response.json(); // если сервер возвращает JSON
      if (result?.message !== 'ok') throw new Error(result?.message);

      onSuccess?.(result);
    } catch (err) {
      console.error("Ошибка при отправке CSV:", err);
      onError?.(err);
    } finally {
      setIsUploading(false);
      event.target.value = ""; // сбросить input
    }
  };

  return (
    <>
      <Button
        onClick={handleClick}
        disabled={isUploading}
        color="primary"
        variant="outlined"
        size="sm"
      >
        {isUploading ? "Uploading..." : label}
      </Button>
      <input
        type="file"
        accept=".csv"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
    </>
  );
}

export default UploadButton;